import { render, staticRenderFns } from "./orders_heatmap.vue?vue&type=template&id=6787de0e&scoped=true&"
import script from "./orders_heatmap.vue?vue&type=script&lang=js&"
export * from "./orders_heatmap.vue?vue&type=script&lang=js&"
import style0 from "./orders_heatmap.vue?vue&type=style&index=0&id=6787de0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6787de0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6787de0e')) {
      api.createRecord('6787de0e', component.options)
    } else {
      api.reload('6787de0e', component.options)
    }
    module.hot.accept("./orders_heatmap.vue?vue&type=template&id=6787de0e&scoped=true&", function () {
      api.rerender('6787de0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/dashboard/addon/orders_heatmap.vue"
export default component.exports